import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/services';
import Services from './Services';
import {resetStore} from "../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.services,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Services);
